import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

// services
import { AuthHttpInterceptor } from '../auth/auth.http.interceptor';
import { StatsService } from './stats.service';

@NgModule({
  imports: [HttpClientModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
  ],
})
export class StatsServiceModule {
  static forRoot(): ModuleWithProviders<StatsServiceModule> {
    return {
      ngModule: StatsServiceModule,
      providers: [StatsService],
    };
  }
}
